<template>
    <div class="page" v-if="canAccessAdmin">
        <header class="navbar navbar-expand-md navbar-light d-none d-lg-flex d-print-none">
            <div class="container-xl">
                <div class="navbar-nav flex-row order-md-last">
                    <div class="nav-item">
                        <a href="/dashboard" class="nav-link">Back to MBx</a>
                    </div>
                    <div class="nav-item">
                            {{userName}}
                    </div>

                    <div class="nav-item">
                        <router-link to="logout" class="nav-link">LOGOUT</router-link>
                    </div>
                </div>
                <div class="collapse navbar-collapse" id="navbar-menu">
                    <div></div>
                </div>
            </div>
        </header>
        <navigation></navigation>
        <div class="page-wrapper">
            <div class="page-body">
                <div class="container-xl">
                    <router-view></router-view>
                </div>
            </div>
        </div>
        <div class="footer-admin">{{ $t('global.multibrain_copyright', {year: (new Date()).getFullYear()}) }}</div>
    </div>
</template>
<script>
import Navigation from '../components/layout/navigation-admin.vue';

import { mapState } from 'pinia'
import { useUser } from '../stores/user';

export default {
    components: {
        Navigation
    },

    computed: {
        ...mapState(useUser, {userName: 'name'}),

        ...mapState(useUser, {canAccessAdmin: 'canAccessAdmin'}),
    },

    mounted() {
        if (!this.canAccessAdmin) {
            window.location = '/dashboard';
        }
    }
}
</script>
<style lang="scss">
    .header-admin {
        background:#1e293b;
        color:#ffffff;
        height:40px;
        padding:5px;
    }
    .footer-admin {
        background:#1e293b;
        color:#ffffff;
        height:20px;
        font-size:14px;
        line-height:14px;
        padding:3px;
        text-align: center;
    }
</style>
